export const MIN_SHAREHOLDERS = 1;
export const MAX_SHAREHOLDERS = 5;
